import { render, staticRenderFns } from "./priceCard.vue?vue&type=template&id=d14e3732&scoped=true"
import script from "./priceCard.vue?vue&type=script&lang=js"
export * from "./priceCard.vue?vue&type=script&lang=js"
import style0 from "./priceCard.vue?vue&type=style&index=0&id=d14e3732&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d14e3732",
  null
  
)

export default component.exports